<template>
  <footer>
    <div class="footer-top">
      <div class="container">
        <div class="row gy-5 align-items-center">
          <div
            class="col-lg-3 d-flex justify-content-center justify-content-lg-end align-items-center"
          >
            <img
              src="@/assets/img/qrcode.jpg"
              alt="公众号二维码"
              style="width: 129px; height: 129px"
            />
          </div>
          <div class="col-lg-6 d-flex justify-content-center">
            <div class="footer-item d-flex flex-column">
              <div class="logo">
                <img src="@/assets/img/logo_white.png" alt="logo图" />
              </div>
              <ul class="footer-list d-flex flex-column">
                <li>
                  <a href="">地址：海口市龙华区国贸路6号瑞特广场23楼</a>
                </li>
                <li><a href="">Tel：0898-6530-5790</a></li>
                <li><a href="">邮箱：public@hiwald.com</a></li>
                <li>
                  <a target="_blank" class="copy_link" href="https://beian.miit.gov.cn"
                    >Copyright &copy; 海南华德科技有限公司 备案号：琼ICP备20002013号-1</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
@import url("../assets/css/style.css");
.logo img {
  width: 120px;
  height: auto;
  margin: 0 auto 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue